import request from "../index";

// 获取新闻列表
export function newList(postdata){
  return request({
      method:"post",
      url:"/news/web/online/page",
      data:postdata
  })
}

// 获取新闻详情
export function newDetail(postdata){
  return request({
      method:"get",
      url:"/news/web/info/",
      data:postdata,
      isparams:true
  })
}


// WEBPACK FOOTER //
// ./src/api/modules/new.js